import { render, staticRenderFns } from "./productConfig.vue?vue&type=template&id=73ca22ee"
import script from "./productConfig.vue?vue&type=script&lang=js"
export * from "./productConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports